<script>
import {defineComponent, ref, watch, computed} from "vue";
import {useStore} from "vuex";

import Editor from "primevue/editor";
import MainCard from "@/components/cards/MainCard";
import FileUpload from "@/components/FileUpload";
import ImagesBuilding from '@/views/buildings/ImagesBuilding.vue'
export default defineComponent({
  components: {Editor, MainCard, FileUpload, ImagesBuilding},
  props: {
    formData: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    }
  },
  emits: ['changeFormData'],
  setup(props, {emit}) {
    const store = useStore();
    const form = ref(props.formData);
    const lang = computed(() => store.getters.getLang);
    const changePhotoArray = (array) => {
      form.value.infrastructure_photos = array
    }

    watch(() => form.value, () => emit('changeFormData', form.value), {deep: true});

    const infrastructureField = computed(() => `infrastructure_${lang.value}`);
    const infrastructureError = computed(() => props.errors?.[infrastructureField.value]);

    return {form, changePhotoArray, lang, infrastructureField, infrastructureError};
  }
});
</script>

<template>
  <section class="py-2 mb-3">
    <div class="grid">
      <div class="col-12">
        <MainCard title="Описание">
          <div class="grid">
            <div class="col-12">
              <Editor v-model="form[infrastructureField]" class="w-full"></Editor>
              <span v-if="infrastructureError" class="text-xs color-error">
                {{ infrastructureError[0] }}
              </span>
            </div>
          </div>
        </MainCard>
      </div>
    </div>
  </section>
  <section class="py-2 mb-3">
    <div class="grid">
      <div class="col-12">
        <ImagesBuilding
            :photos="formData.infrastructure_photos"
            :errors="errors"
            type="infrastructure_photos"
            :files="files"
            @changeFormData="changePhotoArray"
        />
      </div>
    </div>
  </section>
</template>
<style scoped>
</style>